import { c as _c } from "react/compiler-runtime";
import { FunnelDesktopView } from 'modules/funnels/funnel/components/funnel-desktop-view';
import FunnelHeader from 'modules/funnels/funnel/components/funnel-header';
import { FunnelTabletMobileView } from 'modules/funnels/funnel/components/funnel-tablet-mobile-view';
import { FunnelLoco } from 'modules/funnels/funnel/constants/funnel-loco';
import { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum';
import { useFunnelStepQuery } from 'modules/funnels/funnel/hooks/use-funnel-step-query';
import { useFunnelStepsList } from 'modules/funnels/funnel/hooks/use-funnel-steps-list';
import { useUpdateFunnelStepQuery } from 'modules/funnels/funnel/hooks/use-update-funnel-step-query';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { getFunnelSettingsTabList } from 'modules/funnels/funnel/utils/get-funnel-settings-tab-list';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { ViewportSwitch } from 'shared/components/viewport-switch';
import { updateFunnelStepInDB } from 'shared/db/utils/funnels';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
const Funnel: NextPage = () => {
  const $ = _c(41);
  const router = useRouter();
  const funnelId = parseInt(router.query.funnelId as string) as FunnelId;
  const {
    funnelStepsList,
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  const {
    updateFunnelStepQuery
  } = useUpdateFunnelStepQuery();
  const [selectedFunnelStep, setSelectedFunnelStep] = useState(null);
  let t0;
  if ($[0] !== funnelStepsList) {
    t0 = {
      funnelStepsList,
      setSelectedFunnelStep
    };
    $[0] = funnelStepsList;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    selectedFunnelStepId,
    selectedFunnelStepTab
  } = useFunnelStepQuery(t0);
  const t1 = selectedFunnelStep?.type;
  let t2;
  if ($[2] !== t1) {
    t2 = getFunnelSettingsTabList(t1);
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const settingsTabsList = t2;
  const isFunnelListEmpty = funnelStepsList?.length === 0;
  const tabsDisabled = !selectedFunnelStep?.page;
  const activeTab = tabsDisabled ? null : selectedFunnelStepTab ?? FunnelStepSettingTabsEnum.stepConfiguration;
  let t3;
  if ($[4] !== funnelId || $[5] !== updateFunnelStepQuery) {
    t3 = function selectFunnelStep(funnelStep) {
      setSelectedFunnelStep(funnelStep);
      updateFunnelStepQuery(funnelStep.id, FunnelStepSettingTabsEnum.stepConfiguration);
      updateFunnelStepInDB(funnelId, funnelStep.id);
    };
    $[4] = funnelId;
    $[5] = updateFunnelStepQuery;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const selectFunnelStep = t3;
  let t4;
  if ($[7] !== selectedFunnelStep || $[8] !== updateFunnelStepQuery) {
    t4 = function selectFunnelStepTab(tabType) {
      if (!selectedFunnelStep) {
        return;
      }
      updateFunnelStepQuery(selectedFunnelStep.id, tabType);
    };
    $[7] = selectedFunnelStep;
    $[8] = updateFunnelStepQuery;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const selectFunnelStepTab = t4;
  let t5;
  if ($[10] !== funnelId || $[11] !== funnelStepsList || $[12] !== selectedFunnelStep?.id || $[13] !== selectedFunnelStepId) {
    t5 = () => {
      if (funnelStepsList && Number(selectedFunnelStepId) !== selectedFunnelStep?.id) {
        const selectedFunnelStepEntity = funnelStepsList.find(funnelStep_0 => funnelStep_0.id === Number(selectedFunnelStepId));
        if (selectedFunnelStepEntity && selectedFunnelStepId) {
          setSelectedFunnelStep(selectedFunnelStepEntity);
          updateFunnelStepInDB(funnelId, selectedFunnelStepId);
        }
      }
    };
    $[10] = funnelId;
    $[11] = funnelStepsList;
    $[12] = selectedFunnelStep?.id;
    $[13] = selectedFunnelStepId;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== funnelStepsList || $[16] !== selectedFunnelStepId) {
    t6 = [selectedFunnelStepId, funnelStepsList];
    $[15] = funnelStepsList;
    $[16] = selectedFunnelStepId;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  useEffect(t5, t6);
  let t7;
  if ($[18] !== updateFunnelStepQuery) {
    t7 = () => {
      if (window.location.hash) {
        const stepId = window.location.hash.replace("#step", "");
        updateFunnelStepQuery(Number(stepId));
      }
    };
    $[18] = updateFunnelStepQuery;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== router) {
    t8 = [router];
    $[20] = router;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  useEffect(t7, t8);
  let t9;
  if ($[22] !== activeTab || $[23] !== funnelId || $[24] !== funnelStepsList || $[25] !== isFunnelListEmpty || $[26] !== mutateFunnelStepsList || $[27] !== selectFunnelStep || $[28] !== selectFunnelStepTab || $[29] !== selectedFunnelStep || $[30] !== settingsTabsList || $[31] !== tabsDisabled) {
    t9 = {
      activeTab,
      funnelId,
      funnelSteps: funnelStepsList,
      isFunnelListEmpty,
      mutate: mutateFunnelStepsList,
      selectFunnelStep,
      selectFunnelStepTab,
      selectedFunnelStep,
      settingsTabs: settingsTabsList,
      tabsDisabled
    };
    $[22] = activeTab;
    $[23] = funnelId;
    $[24] = funnelStepsList;
    $[25] = isFunnelListEmpty;
    $[26] = mutateFunnelStepsList;
    $[27] = selectFunnelStep;
    $[28] = selectFunnelStepTab;
    $[29] = selectedFunnelStep;
    $[30] = settingsTabsList;
    $[31] = tabsDisabled;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  const viewProps = t9;
  let t10;
  if ($[33] !== funnelId || $[34] !== selectedFunnelStep) {
    t10 = <FunnelHeader funnelId={funnelId} selectedFunnelStep={selectedFunnelStep} />;
    $[33] = funnelId;
    $[34] = selectedFunnelStep;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== viewProps) {
    t11 = <ViewportSwitch at="desktop" below={<FunnelTabletMobileView {...viewProps} />} from={<FunnelDesktopView {...viewProps} />} />;
    $[36] = viewProps;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== t10 || $[39] !== t11) {
    t12 = <div className="flex flex-col">{t10}{t11}</div>;
    $[38] = t10;
    $[39] = t11;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  return t12;
};
export const getServerSideProps = getBaseServerSideProps(FunnelLoco, 'header.top_menu.funnels');
export default Funnel;